// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio__assessors .custom-control-label{width:100%}.radio__assessors .custom-control-label:after,.radio__assessors .custom-control-label:before{top:1.1rem}", ""]);
// Exports
module.exports = exports;
